import React, { lazy } from "react";

import { VIEW_ACTION_LOG_PERMISSION } from "constants/permissions";

const ActionLogPage = lazy(() => import("./ActionLogPage"));

const actionLogRoute = {
  path: "action_log",
  element: <ActionLogPage />,
  root: true,
  permission: VIEW_ACTION_LOG_PERMISSION,
};

export default actionLogRoute;
